import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Icon } from '@fluentui/react'

import { AppStateContext } from '../../state/AppProvider'
import styles from './Home.module.css'

interface QuickLink {
  path: string
  label: string
  icon: string
  description: string
}

const QUICK_LINKS: QuickLink[] = [
  { path: '/candidates', label: 'Candidates', icon: 'People', description: 'Browse, search, and manage candidate profiles.' },
  { path: '/clients', label: 'Clients', icon: 'CityNext', description: 'View client accounts and contact history.' },
  { path: '/jobs', label: 'Jobs', icon: 'Suitcase', description: 'Track open positions and applications.' },
  { path: '/market', label: 'Market', icon: 'SearchNearby', description: 'Discover jobs across the wider market.' },
  { path: '/emails', label: 'Email', icon: 'Mail', description: 'Review sent emails and bulk campaigns.' },
  { path: '/candidate-messages', label: 'Messages', icon: 'ChatBot', description: 'Read and reply to candidate messages.' },
]

const Home = () => {
  const navigate = useNavigate()
  const appStateContext = useContext(AppStateContext)
  const user = appStateContext?.state.user

  const greetingName = (() => {
    const source = user?.full_name || user?.username || ''
    const first = source.trim().split(/\s+/)[0]
    return first || 'there'
  })()

  const hour = new Date().getHours()
  const timeOfDay = hour < 12 ? 'morning' : hour < 18 ? 'afternoon' : 'evening'

  return (
    <div className={styles.container}>
      <section className={styles.hero}>
        <div className={styles.heroText}>
          <p className={styles.heroEyebrow}>{user?.agency_name || 'CDreams'}</p>
          <h1 className={styles.heroTitle}>Good {timeOfDay}, {greetingName}.</h1>
          <p className={styles.heroSub}>
            Jump into a section below, or tap <strong>Ask CDreams</strong> in the top-right to chat with your AI assistant.
          </p>
        </div>
        <div className={styles.heroBadge} aria-hidden="true">
          <Icon iconName="ChatBot" />
        </div>
      </section>

      <section aria-label="Quick links" className={styles.cardsSection}>
        <h2 className={styles.sectionTitle}>Quick links</h2>
        <div className={styles.cardsGrid}>
          {QUICK_LINKS.map(link => (
            <button
              key={link.path}
              type="button"
              className={styles.card}
              onClick={() => navigate(link.path)}
            >
              <span className={styles.cardIcon}>
                <Icon iconName={link.icon} />
              </span>
              <span className={styles.cardBody}>
                <span className={styles.cardLabel}>{link.label}</span>
                <span className={styles.cardDescription}>{link.description}</span>
              </span>
              <span className={styles.cardArrow} aria-hidden="true">
                <Icon iconName="ChevronRight" />
              </span>
            </button>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Home
